import { combineReducers } from "redux";

import toast from "./toast/index";
import modal from "./modal/index";
import loader from "./loader/index";
import planReducer from "./plans/index";
import orderDetailsReducer from "./orderDetails/index";
import orderFeeReducer from "./orderFee/index";
import liveStatusReducer from "./liveStatus";

const rootReducer = combineReducers({
  // customizer,
  // auth,
  // navbar,
  planReducer,
  toast,
  modal,
  loader,
  orderDetailsReducer,
  orderFeeReducer,
  liveStatusReducer
});

export default rootReducer;
export type AppState = ReturnType<typeof rootReducer>;
